import { environmentConfig } from './environment';

export const firebaseConfig = environmentConfig.firebase;
